import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetClientsBySearch(club, url) {

  var url = "/reservation/get_client_by_search/" + club + url; 

  return FetchGetDataWithAuthNEW(url);
}

